import { useContext } from 'react';
import { DoctorWorkspaceContext } from '../components/doctor/doctorWorkspaceContext';
import { NurseWorkspaceContext } from '../components/nurse/nurseWorkspaceContext';

/** Sites de travail partagés entre portails médecin / infirmière (LocalPharmacyPage, etc.). */
export function useClinicalLayoutContext() {
  const doctorCtx = useContext(DoctorWorkspaceContext);
  const nurseCtx = useContext(NurseWorkspaceContext);
  return doctorCtx || nurseCtx || {};
}
